import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../../../config/apiConfig';
import { FaChevronDown, FaEye, FaTrash } from 'react-icons/fa';
import { LoadingSpinner } from '../../general/LoadingSpinner';

export const AnalyticsCaseHistory = ({ onViewCase }) => {
  const [expanded, setExpanded] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const authToken = localStorage.getItem("authToken");

  const togglePanel = () => setExpanded(!expanded);

  useEffect(() => {
    setLoading(true);
    axios.get(API_ENDPOINTS.getAllOptimizations, { headers: { Authorization: `Token ${authToken}` } })
      .then(response => {
        if (Array.isArray(response.data)) {
          const sortedData = response.data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
          setTableData(sortedData);
        }
      })
      .catch(error => console.error("Error fetching optimizations:", error))
      .finally(() => setLoading(false));
  }, [authToken]);

  const handleViewCase = (caseId) => {
    setLoading(true);
    axios.get(API_ENDPOINTS.getOptimization, { 
        headers: { Authorization: `Token ${authToken}` },
        params: { case_id: caseId } 
    })
      .then(response => onViewCase(response.data))
      .catch(error => console.error('Error fetching case:', error))
      .finally(() => setLoading(false));
  };

  const handleDeleteCase = (caseId, caseName) => {
    if (window.confirm(`Are you sure you want to delete "${caseName}"? This action cannot be undone.`)) {
      setLoading(true);
      axios.delete(API_ENDPOINTS.deleteOptimization, {
          headers: { Authorization: `Token ${authToken}` },
          params: { case_id: caseId }
      })
        .then(() => {
          setTableData(prevData => prevData.filter(item => item.id !== caseId));
          alert('Case deleted successfully.');
        })
        .catch(error => {
            console.error('Error deleting case:', error);
            alert('Failed to delete case.');
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-200">
      {loading && <LoadingSpinner message="Processing..." />}
      <div 
        className="flex justify-between items-center p-4 cursor-pointer bg-gray-50 hover:bg-gray-100 rounded-t-lg"
        onClick={togglePanel}
      >
        <h3 className="text-lg font-semibold font-nunito text-gray-700">View Previous Cases</h3>
        <FaChevronDown className={`transition-transform duration-300 ${expanded ? 'rotate-180' : ''}`} />
      </div>

      <div className={`transition-all duration-500 ease-in-out overflow-hidden ${expanded ? 'max-h-[1000px]' : 'max-h-0'}`}>
        <div className="p-4">
            {tableData.length > 0 ? (
                 <div className="overflow-x-auto">
                    <table className="w-full text-sm text-left text-gray-600">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100">
                            <tr>
                                <th scope="col" className="px-6 py-3 font-nunito">Case Name</th>
                                <th scope="col" className="px-6 py-3 font-nunito">Timestamp</th>
                                <th scope="col" className="px-6 py-3 text-center font-nunito">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((item) => (
                                <tr key={item.id} className="bg-white border-b hover:bg-gray-50">
                                    <td className="px-6 py-4 font-medium font-nunito text-gray-900 whitespace-nowrap">{item.case_name}</td>
                                    <td className="px-6 py-4 font-nunito">{new Date(item.timestamp).toLocaleString()}</td>
                                    <td className="px-6 py-4 text-center font-nunito">
                                        <button 
                                            onClick={() => handleViewCase(item.id)}
                                            className="inline-flex items-center gap-2 font-medium font-nunito text-blue-600 hover:text-blue-800 mr-4"
                                            title="View Case"
                                        >
                                            <FaEye /> View
                                        </button>
                                        <button 
                                            onClick={() => handleDeleteCase(item.id, item.case_name)}
                                            className="inline-flex items-center gap-2 font-medium text-red-600 hover:text-red-800"
                                            title="Delete Case"
                                        >
                                            <FaTrash /> Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <p className="text-center text-gray-500 py-4">No case history found.</p>
            )}
        </div>
      </div>
    </div>
  );
}; 